module.exports = __webpack_public_path__ + "img/VISA_LOCAL.ed6d29aa.svg";